import * as yup from 'yup';
import {
  firstName,
  getEmailSchema,
  lastName,
  lastNameSecond,
  password,
  passwordConfirmation,
} from 'utils/schemaUtils';

export default yup.object({
  email: getEmailSchema({ section: 'signup' }),
  firstName,
  lastName,
  password,
  passwordConfirmation,
  secondLastName: lastNameSecond,
});
